import { BUTTON_TYPES, createBlock, EditorState } from 'wix-rich-content-editor-common';
import { Version, GALLERY_TYPE } from 'wix-rich-content-common';
import { getPluginParams } from './getPluginParams.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function generateInsertPluginButtonProps({
  blockType,
  button,
  helpers,
  pubsub,
  commonPubsub,
  settings,
  t,
  theme,
  isMobile,
  pluginDefaults,
  getEditorState,
  setEditorState,
  toolbarName,
  pluginMenuButtonRef,
  closePluginMenu,
  experiments = {},
  uploadService,
  updateService
}) {
  const onPluginAdd = () => {
    var _a;
    return (_a = helpers == null ? void 0 : helpers.onPluginAdd) == null ? void 0 : _a.call(helpers, blockType, toolbarName);
  };
  const onPluginAddStep = (step, blockKey, params) => {
    var _a;
    (_a = helpers == null ? void 0 : helpers.onPluginAddStep) == null ? void 0 : _a.call(helpers, {
      version: Version.currentVersion,
      entryType: toolbarName,
      //plusButton = SIDE, moreButton = SHORTCUT, footer = FOOTER
      entryPoint: toolbarName,
      params,
      pluginId: blockType,
      pluginDetails: blockKey,
      step
    });
  };
  const onPluginModalOpened = () => {
    var _a;
    (_a = helpers == null ? void 0 : helpers.onPluginModalOpened) == null ? void 0 : _a.call(helpers, {
      version: Version.currentVersion,
      entryType: toolbarName,
      entryPoint: toolbarName,
      pluginId: blockType,
      pluginDetails: void 0
    });
  };
  const onPluginAddSuccess = (params = {}) => {
    var _a;
    return (_a = helpers == null ? void 0 : helpers.onPluginAddSuccess) == null ? void 0 : _a.call(helpers, blockType, toolbarName, params);
  };
  function addBlock(data, beforeAdd) {
    const { componentData } = data;
    const { newBlock, newSelection, newEditorState } = createBlock(
      getEditorState(),
      componentData,
      blockType
    );
    const params = getPluginParams(data, blockType);
    const blockKey = newBlock.getKey();
    beforeAdd == null ? void 0 : beforeAdd(blockKey, params);
    setEditorState(EditorState.forceSelection(newEditorState, newSelection));
    onPluginAddSuccess(params);
    return { newBlock, newSelection, newEditorState };
  }
  function addCustomBlock(buttonData) {
    var _a;
    onPluginAdd();
    (_a = buttonData.addBlockHandler) == null ? void 0 : _a.call(buttonData, getEditorState());
    onPluginAddSuccess();
  }
  function createBlocksFromFiles(files, data, type, updateEntity) {
    let editorState = getEditorState();
    let selection;
    onPluginAdd();
    const updateEntities = [];
    files.forEach((file) => {
      const { newBlock, newSelection, newEditorState } = createBlock(editorState, data, type);
      editorState = newEditorState;
      selection = selection || newSelection;
      updateEntities.push(() => updateEntity(newBlock.getKey(), file));
      onPluginAddSuccess({ pluginDetails: newBlock.getKey() });
    });
    return {
      newEditorState: editorState,
      newSelection: selection,
      updateEntities
    };
  }
  function onClick(event) {
    event.preventDefault();
    const { name, componentData, type } = button;
    const shouldClosePluginMenu = !isMobile || isMobile && type !== "modal";
    switch (type) {
      case "file":
        toggleFileSelection();
        break;
      case "modal":
        toggleButtonModal(event);
        break;
      case "custom-block":
        addCustomBlock(button);
        break;
      case BUTTON_TYPES.BUTTON:
        onPluginAdd();
        if (button.onClick) {
          button.onClick(event);
        } else {
          addBlock({ name, componentData });
        }
        break;
      default:
        onPluginAdd();
        addBlock({ name, componentData });
        break;
    }
    shouldClosePluginMenu && (closePluginMenu == null ? void 0 : closePluginMenu());
  }
  function shouldCreateGallery(files) {
    return blockType === GALLERY_TYPE || pluginDefaults[GALLERY_TYPE] && settings.createGalleryForMultipleImages && files.length > 1;
  }
  function handleFileChange(files, updateEntity) {
    if (files.length > 0) {
      const galleryData = pluginDefaults[GALLERY_TYPE];
      const { newEditorState, newSelection, updateEntities } = shouldCreateGallery(files) ? createBlocksFromFiles([files], galleryData, GALLERY_TYPE, updateEntity) : createBlocksFromFiles(files, button.componentData, blockType, updateEntity);
      setEditorState(EditorState.forceSelection(newEditorState, newSelection));
      updateEntities.forEach((updateEntity2) => updateEntity2());
    }
  }
  function onChange(files) {
    const updateEntity = (blockKey, file) => {
      const state = { userSelectedFiles: { files: Array.isArray(file) ? file : [file] } };
      commonPubsub.set("initialState_" + blockKey, state);
    };
    return handleFileChange(files, updateEntity);
  }
  function handleExternalFileChanged({ data, error }) {
    if (data) {
      const handleFilesAdded = shouldCreateGallery(data) ? (blockKey) => commonPubsub.getBlockHandler("galleryHandleFilesAdded", blockKey) : (blockKey) => pubsub.getBlockHandler("handleFilesAdded", blockKey);
      const updateEntity = (blockKey, file) => {
        onPluginAddStep("FileUploadDialog", blockKey);
        setTimeout(() => {
          handleFilesAdded(blockKey)({ data: file, error });
        });
      };
      handleFileChange(data, updateEntity);
    }
  }
  function toggleButtonModal(event) {
    onPluginAdd();
    if (helpers && helpers.openModal) {
      onPluginModalOpened();
      let modalStyles = {};
      if (button.modalStyles) {
        modalStyles = button.modalStyles;
      } else if (button.modalStylesFn) {
        modalStyles = button.modalStylesFn({
          buttonRef: pluginMenuButtonRef || event.target,
          pubsub,
          toolbarName
        });
      }
      let addedBlockKey;
      helpers.openModal({
        modalName: button.modalName,
        modalElement: button.modalElement,
        modalDecorations: button.modalDecorations,
        buttonRef: event.target,
        modalStyles,
        theme,
        componentData: button.componentData,
        onConfirm: (componentData) => {
          const data = { componentData, buttonName: button.name };
          const blockData = addBlock(
            data,
            (key, params) => onPluginAddStep("PluginModal", key, params)
          );
          addedBlockKey = blockData.newBlock;
          return blockData;
        },
        pubsub,
        helpers,
        t,
        isMobile,
        blockKey: addedBlockKey,
        toolbarName,
        pluginId: blockType
      });
    }
  }
  function toggleFileSelection() {
    if (settings == null ? void 0 : settings.handleFileSelection) {
      settings.handleFileSelection(handleExternalFileChanged);
    } else if (helpers == null ? void 0 : helpers.handleFileSelection) {
      const multiple = !!button.multi;
      helpers.handleFileSelection(
        void 0,
        multiple,
        handleExternalFileChanged,
        void 0,
        button.componentData
      );
    }
  }
  function isFileInput() {
    return button.type === BUTTON_TYPES.FILE && !settings.handleFileSelection && !helpers.handleFileSelection;
  }
  function getButtonType() {
    return isFileInput() ? BUTTON_TYPES.FILE : BUTTON_TYPES.BUTTON;
  }
  function getPropsByButtonType(type) {
    return {
      [BUTTON_TYPES.FILE]: { onChange, accept: settings.accept, multiple: button.multi },
      [BUTTON_TYPES.BUTTON]: { onClick }
    }[type];
  }
  return __spreadValues({
    name: button.name,
    getIcon: button.getIcon,
    tooltip: button.tooltip,
    dataHook: `${button.name}`,
    getLabel: () => t(button.name),
    isDisabled: button.isDisabled || (() => false),
    isActive: button.isActive || (() => false),
    type: getButtonType(),
    toolbars: button.toolbars
  }, getPropsByButtonType(getButtonType()));
}

export { generateInsertPluginButtonProps };
//# sourceMappingURL=generateInsertPluginButtonProps.js.map
